import Immutable from 'immutable';

const Content: {
  action: string,
  items: Immutable.List<any>,
  ids: Immutable.List<string>
} = {
  action: '',
  items: Immutable.List(),
  ids: Immutable.List()
}

class UpdateAction extends Immutable.Record(Content) {
}

export default UpdateAction;
